import types from './types';

export default (
  state = {
    isFetchingAnswers: false,
    answers: [],
    answersError: "",
  }, action
) => {
  switch (action.type) {
    case types.GET_ANSWERS_BY_SESSION_REQUEST:
      return {
        ...state,
        isFetchingAnswers: action.isFetchingAnswers
      };
    case types.GET_ANSWERS_BY_SESSION_COMPLETED:
      return {
        ...state,
        isFetchingAnswers: action.isFetchingAnswers,
        answers: action.answers
      };
    case types.GET_ANSWERS_BY_SESSION_ERROR:
      return {
        ...state,
        isFetchingAnswers: action.isFetchingAnswers,
        answersError: action.answersError
      };

    default:
      return state;
  }
};
